module.exports = __webpack_public_path__ + "img/requirementEngineering.02618882.jpg";